import React, { useContext, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { useForm } from 'react-hook-form';
import { Button, Card, CardBody, Col, CustomInput, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import WizardInput from '../../../components/auth/wizard/WizardInput';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import SimulatorPage from '../../simulator/SimulatorPage';
import { SolicitudContext } from '../SolicitudContext';

const GeneralConditions = () => {
    const [selectedLine, setSelectedLine] = useState();
    const [isPrefijo, setIsPrefijo] = useState(false);
    const [creditNumber, setCreditNumber] = useState('');
    const { register, triggerValidation, errors, setValue, getValues } = useForm();
    const {
        date,
        formCreditInfo,
        creditLinesOptions,
        creditSublinesOptions,
        disabledCutDate,
        onSave,
        lastDay,
        handleCreditForm,
        handleCutDate,
        handleCreditInfoForm,
        loadCreditSublines,
        onChangeLine,
        loading } = useContext(SolicitudContext);

    const getLineDataById = (lineId) => {
        const line = creditLinesOptions.find(item => item.id === parseInt(lineId));
        return {
            consecutivo: line?.consecutivo || '',
            prefijo: line?.prefijo || ''
        };
    };

    const getDisplayCreditNumber = () => {
        if (!isPrefijo || !selectedLine) return creditNumber;
        const { prefijo } = getLineDataById(selectedLine);
        const formattedConsecutivo = String(creditNumber).padStart(7, '0');
        return prefijo ? `${prefijo}-${formattedConsecutivo}` : formattedConsecutivo;
    };

    const handlePrefijoChange = async (checked) => {
        setIsPrefijo(checked);
        if (checked && selectedLine) {
            const { consecutivo } = getLineDataById(selectedLine);
            setCreditNumber(consecutivo);
            setValue('creditNumber', consecutivo);
        }
        const formCreditInfo = getValues();
        await triggerValidation();
        const isValid = Object.keys(errors).length < 1;
        handleCreditInfoForm(isValid ? { ...formCreditInfo, automatico: checked ? 1 : 0 } : null);
    };

    const onChange = async e => {
        const { name, value } = e.target;
        if (name === 'creditLine') {
            var checked = value != '1';
            setIsPrefijo(checked);
            setSelectedLine(value);
            loadCreditSublines(value);
            onChangeLine(value);
            setValue('creditSubline', null);
            if (checked) {
                const { consecutivo } = getLineDataById(value);
                setCreditNumber(consecutivo);
                setValue('creditNumber', consecutivo);
            } else {
                setCreditNumber('');
                setValue('creditNumber', '');
            }
        }
        setValue(name, value);
        const formCreditInfo = getValues();
        await triggerValidation();
        const isValid = Object.keys(errors).length < 1;
        handleCreditInfoForm(isValid ? { ...formCreditInfo, automatico: isPrefijo ? 1 : 0 } : null);
    }

    return (
        <Card className={`my-3`} style={{ backgroundColor: "#1b97ebd1", color: "white" }} >
            <FalconCardHeader title="Condiciones Generales"></FalconCardHeader>
            <CardBody className="border-top">
                <form onChange={onChange}>
                    <Row>
                        <Col xl={12}>
                            <FormGroup>
                                <Label for="creditLine">
                                    <span className='mr-1 text-danger'>*</span>
                                    Línea de Crédito
                                </Label>
                                <WizardInput
                                    type="select"
                                    tag={CustomInput}
                                    placeholder="Seleccionar"
                                    id="creditLine"
                                    name="creditLine"
                                    options={creditLinesOptions.map(item => (
                                        { label: item.nombre, value: item.id }
                                    ))}
                                    errors={errors}
                                    innerRef={register({
                                        required: true,
                                    })}
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={12}>
                            <FormGroup>
                                <Label for="creditSubline">
                                    <span className='mr-1 text-danger'>*</span>
                                    Sublínea de Crédito
                                </Label>
                                <WizardInput
                                    type="select"
                                    tag={CustomInput}
                                    placeholder="Seleccionar"
                                    id="creditSubline"
                                    name="creditSubline"
                                    options={creditSublinesOptions.map(item => (
                                        { label: item.nombre, value: item.id }
                                    ))}
                                    errors={errors}
                                    innerRef={register({
                                        required: true,
                                    })}
                                />
                            </FormGroup>
                        </Col>
                        <Col xl={12}>
                            <FormGroup>
                                <Label for="creditNumber">
                                    <span className='mr-1 text-danger'>*</span>
                                    Nro. del Crédito
                                </Label>
                                {isPrefijo ? (
                                    <Input
                                        className="form-control"
                                        value={getDisplayCreditNumber()}
                                        disabled
                                        readOnly
                                    />
                                ) : (
                                    <CurrencyInput
                                        className="form-control"
                                        allowNegativeValue={false}
                                        allowDecimals={false}
                                        disableGroupSeparators={true}
                                        value={creditNumber}
                                        name="creditNumber"
                                        id="creditNumber"
                                        onValueChange={(value) => setCreditNumber(value || '')}
                                        {...register("creditNumber", {
                                            required: !isPrefijo,
                                        })}
                                        decimalsLimit={0}
                                        maxLength={20}
                                        placeholder="0" />
                                )}
                                <div className="d-flex">
                                    <CustomInput
                                        type="switch"
                                        name="prefijo"
                                        id="prefijo"
                                        checked={isPrefijo}
                                        onChange={(e) => handlePrefijoChange(e.target.checked)}
                                        disabled
                                    />
                                    <Label for="prefijo">
                                        Automático
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
                <SimulatorPage
                    handleSubmit={handleCreditForm}
                    inLine={selectedLine}
                    onChangeDate={handleCutDate}
                    minDate={date}
                    lastDay={lastDay}
                    bgColor="transparent"
                    invisibleFields={{ date: true, creditLine: true }}
                    disabledDate={disabledCutDate}
                    vertical
                    noShadow
                    noHeader
                    requiredMark />
                <Row className="mt-4">
                    <Col lg={6} xs={12}>
                        <Button className="w-100" transform="shrink-3 down-2" color="falcon-default" >
                            {loading ? (
                                <Spinner size="sm" color="primary" />
                            ) : "Cancelar"}
                        </Button>
                    </Col>
                    <Col lg={6} xs={12}>
                        <Button onClick={onSave} className="w-100" transform="shrink-3 down-2" color="primary" >
                            {loading ? (
                                <Spinner size="sm" color="light" />
                            ) : "Guardar"}
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
};

export default GeneralConditions;
